// 封装一个公共的 HTTP 请求类
import BaseService from "@/api/base";

class PasswordService extends BaseService {
    // 基础的 API 地址
    private create_path = "/1password/api/v1/password/create"
    private update_path = "/1password/api/v1/password/update"
    private search_at_page_path = "/1password/api/v1/password/search_at_page"
    private remove_path = "/1password/api/v1/password/remove"
    private decryption_path = "/1password/api/v1/password/decryption"
    private find_by_id_path = "/1password/api/v1/password/find_by_id"
    private change_category_path = "/1password/api/v1/password/change_category"

    public async save(data: any = {}): Promise<any> {
        if (data.id == null) {
            return await this.postFetchData(this.create_path, data);
        }
        return await this.postFetchData(this.update_path, data);
    }

    // 封装 GET 请求方法
    public async searchAtPage(query: any = {}): Promise<any> {
        return await this.getFetchData(this.search_at_page_path, query);
    }

    public async remove(data: any = {}): Promise<any> {

        return await this.postFetchData(this.remove_path, data);
    }

    public async decryption(query: any = {}): Promise<any> {
        return await this.getFetchData(this.decryption_path, query);
    }

    public async findById(query: any = {}): Promise<any> {
        return await this.getFetchData(this.find_by_id_path, query);
    }

    public async changeCategory(form: any = {}): Promise<any> {
        return await this.postFetchData(this.change_category_path, form);
    }

}

export default PasswordService;
